export const RETRIEVE_CATEGORIES = "RETRIEVE_CATEGORIES";
